window.addEventListener('DOMContentLoaded', function() {
	const newsletterPopup = document.querySelector('#newsletter-popup');
	const newsletterPopupCloseButton = document.querySelector('#newsletter-popup-close');
	const newsletterThanksPopup = document.querySelector('#newsletter-thanks');

	newsletterPopupCloseButton.addEventListener('click', function(event) {
		toggleNewsletterVisibility(false);
		setLastHidden();
	});

	function setLastHidden() {
		window.localStorage.setItem('weastcoast-newsletter-last-hidden', ((new Date()).getTime() / 1000));
	}

	function toggleNewsletterVisibility(shown = false) {
		newsletterPopup.style.bottom = shown ? "0px" : "-300px";
	}

	function toggleNewsletterThanksVisibility(shown = false) {
		newsletterThanksPopup.style.bottom = shown ? "0px" : "-300px";
	}

	setTimeout(function() {
		const lastHidden = window.localStorage.getItem('weastcoast-newsletter-last-hidden');
		const now = ((new Date()).getTime() / 1000);

		if (window.location.search == "?form_type=customer" || window.location.search == "?customer_posted=true") {
			toggleNewsletterThanksVisibility(true);
			setLastHidden();
			setTimeout(function() {
				toggleNewsletterThanksVisibility(false);
			}, 3500);
		} else if (lastHidden == undefined || (now - lastHidden) > 86400) {
			toggleNewsletterVisibility(true);
		}
	}, 500);

	const cartSidebarWrapper = document.querySelector('#cart-sidebar-wrapper');
	const cartAdders = document.querySelectorAll('[data-cart-add]');
	
	const cartOpeners = document.querySelectorAll('[href="/cart"]');
	const cartClosers = document.querySelectorAll('[data-cart-close]');
	
	function toggleCart(shown = true) {
		cartSidebarWrapper.style.right = shown ? '0%' : '-400px';
		cartSidebarWrapper.setAttribute('data-shown', shown);
	}
	
	function addItem(id, callback) {
		fetch(window.Shopify.routes.root + 'cart/add.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({
					'items': [{
						'id': id,
						'quantity': 1
					}],
					sections: 'cart-sidebar'
				})
			})
			.then(response => {
				return response.json();
			})
			.then(data => {
				if (callback) {
					callback(data);
				}
				updateCartDisplay();
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	}
	
	function updateItem(key, quantity, callback) {
		fetch(window.Shopify.routes.root + 'cart/update.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				updates: { [key]: quantity },
				sections: 'cart-sidebar'
			})
		})
		.then(response => {
			return response.json();
		})
		.then(data => {
			if (callback) {
				callback(data);
			}
			updateCartDisplay();
		})
		.catch((error) => {
			console.error('Error:', error);
		});
	}
	
	function updateCartDisplay(callback) {
		fetch(window.Shopify.routes.root + 'cart.js', {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json'
			}
		})
		.then(response => {
			return response.json();
		})
		.then(data => {
			if (callback) {
				callback(data);
			}
			document.querySelectorAll('[data-cart-count]').forEach(function(cartDisplay){
				cartDisplay.innerHTML = data.item_count;
			});
		})
		.catch((error) => {
			console.error('Error:', error);
		});
	}
	
	document.addEventListener("keydown", function(event) {
		if (cartSidebarWrapper.getAttribute('data-shown') == "false") {
			return;
		}
		
		switch (event.keyCode) {
			case 27:
				toggleCart(false);
				break;
			default:
				break;
		}
	});
	
	cartSidebarWrapper.addEventListener('click', function(event) {
		if (event.target.closest('[data-cart-close]')) {
			toggleCart(false);
		}
		
		const remover = event.target.closest('[data-cart-remove]');
		if (remover) {
			event.preventDefault();
			remover.setAttribute('disabled', true);

			updateItem(remover.getAttribute('data-cart-remove'), 0, function(data) {
				cartSidebarWrapper.innerHTML = data.sections["cart-sidebar"];
				remover.removeAttribute('disabled');
			});
		}
	});
	
	let cartUpdateTimers = {};
	cartSidebarWrapper.addEventListener('change', function(event) {
		const updater = event.target.closest('[data-cart-update]');
		if (updater) {
			const updaterKey = updater.getAttribute('data-cart-update');
			clearTimeout(cartUpdateTimers[updaterKey]);
			cartUpdateTimers[updaterKey] = setTimeout(function() {
				updater.setAttribute('disabled', true);
				updateItem(updaterKey, parseInt(updater.value), function(data) {
					cartSidebarWrapper.innerHTML = data.sections["cart-sidebar"];
					updater.removeAttribute('disabled');
				});
			}, 400);
		}
	});

	
	cartOpeners.forEach(function(cartOpener){
		cartOpener.addEventListener('click', function(event){
			event.preventDefault();
			toggleCart(true);
		});
	});
	
	cartClosers.forEach(function(cartCloser){
		cartCloser.addEventListener('click', function(event){
			event.preventDefault();
			toggleCart(false);
		});
	});
		
	cartAdders.forEach(function(cartAdder){
		cartAdder.addEventListener('click', function(event){
			event.preventDefault();
			cartAdder.setAttribute('disabled', true);
			addItem(cartAdder.getAttribute('data-cart-add'), function(data) {
				cartSidebarWrapper.innerHTML = data.sections["cart-sidebar"];
				cartAdder.removeAttribute('disabled');
				toggleCart(true);
			});
		});
	});
	
	const cartVariantSelectors = document.querySelectorAll('[data-cart-variant]');
	cartVariantSelectors.forEach(function(cartVariantSelector){
		cartVariantSelector.addEventListener('change', function(event){
			const targetedButtons = document.querySelectorAll('[data-cart-variant-target="' + cartVariantSelector.getAttribute('data-cart-variant') + '"]');
			targetedButtons.forEach(function(targetedButton) {
				targetedButton.setAttribute('data-cart-add', cartVariantSelector.value);
			});
		});
	});

});